import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getUserOwnTractorTotalCount } from '../../../../api/user/queries/getUserOwnTractorTotalCount';

export interface IUseGetUserOwnTractorTotalCountParams {
  searchParam: {
    machineApprovalStatus: string;
    isPokeEnabled: boolean;
    minEngineOutputPs: number;
    maxEngineOutputPs: number;
    brand?: string;
    regionDepth1?: string;
  };
  options?: UseQueryOptions<IUseGetUserOwnTractorTotalCountReturn, AxiosError>;
}

export interface IUseGetUserOwnTractorTotalCountReturn {
  count: number;
}

export const useGetUserOwnTractorTotalCountQuery = ({
  searchParam,
  options,
}: IUseGetUserOwnTractorTotalCountParams) => {
  return useQuery<IUseGetUserOwnTractorTotalCountReturn, AxiosError>(
    [
      'user-own-tractors-total-count',
      `machineApprovalStatus=${searchParam.machineApprovalStatus}`,
      `isPokeEnabled=${searchParam.isPokeEnabled}`,
      `minEngineOutputPs=${searchParam.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam.maxEngineOutputPs}`,
      `brand=${searchParam.brand}`,
      `regionDepth1=${searchParam.regionDepth1}`,
    ],
    () => getUserOwnTractorTotalCount({ searchParam }),
    options,
  );
};
